import React from "react";
import {
  Card,
  Image,
  Text,
  Badge,
  Button,
  Group,
  Title,
  Flex,
} from "@mantine/core";
import { useNavigate } from "react-router-dom";

function Demo() {
  const navigate = useNavigate();

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Card.Section>
        <Image
          src="https://images.unsplash.com/photo-1527004013197-933c4bb611b3?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=720&q=80"
          height={160}
          alt="Norway"
        />
      </Card.Section>

      <Group position="apart" mt="md" mb="xs">
        <Text weight={500}>Python Course</Text>
        <Badge color="green" variant="light">
          free
        </Badge>
      </Group>

      <Text size="sm" color="dimmed">
        With Fjord Tours you can explore more of the magical fjord landscapes
        with tours and activities on and around the fjords of Norway
      </Text>

      <Button
        variant="light"
        color="blue"
        fullWidth
        mt="md"
        radius="md"
        onClick={() => navigate("/course")}
      >
        Start the course now
      </Button>
    </Card>
  );
}

const PromptedCourseList = () => {
  return (
    <div>
      <Title mb={20}>Courses</Title>
      <Flex gap={20} mb={20}>
        <Demo />
        <Demo />
        <Demo />
      </Flex>
      <Flex gap={20} mb={20}>
        <Demo />
        <Demo />
        <Demo />
      </Flex>
      <Flex gap={20} mb={20}>
        <Demo />
        <Demo />
        <Demo />
      </Flex>
    </div>
  );
};

export default PromptedCourseList;
